import { lazy } from 'react';

export const EducationPortalAsync = lazy(() =>
  // eslint-disable-next-line promise/prefer-await-to-then
  import('./EducationPortalRoutes').then((module) => ({
    default: module.EducationPortalRoutes,
  })),
);
